import qs from 'qs';
let curNodeInfo = null;
let shareApi = function () {
  /************ESS1.0***************/
  // 获取账号组列表
  this.getAccountGroupOption = function (params, noLoading,cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('AccountGroups/PagingOption', params, { headers: { noLoading: noLoading }, cancelToken: cancelToken, baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
   // 获取账号组列表
   this.getAccountOption = function (params, noLoading, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Accounts/Options', params, { headers: { noLoading: noLoading }, cancelToken: cancelToken, baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
  // 获取AccessCode列表
  this.getAccessCodeList = function (params, noLoading) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('AccessCode/Query', params, { headers: { noLoading: noLoading } }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
  // 获取department列表
  this.getDepartment = function (searchParams) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Department/Query', searchParams).then((res) => {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
  // 获取账号组列表
  this.getDepartmentOption = function (params, noLoading, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Department/PagingOptions', params, { headers: { noLoading: noLoading }, cancelToken: cancelToken}).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
  // 查询tag列表
  this.getTagsList = function (searchParams, loadFlag, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Tag/PagingOption', searchParams, { headers: { noLoading: loadFlag }, codes: ['M_TagManagement'], cancelToken: cancelToken }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data.items, res.data.data)
      } else {
        deferred.reject(res.data.message);
      }
    }).catch(() => {
      deferred.reject('');
    });
    return deferred;
  }
  
  // 查询tag下拉列表
  this.getTagOptions = function (searchParams, loadFlag, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Tag/PagingOption', searchParams, { headers: { noLoading: loadFlag }, cancelToken: cancelToken }).then((res) => {
      if (res.data.success) {
        deferred.resolve(res.data.data.items, res.data.data);
      } else {
        deferred.reject(res.data.message);
      }
    }).catch(() => {
      deferred.reject('');
    });
    return deferred;
  }

  // 获取卡号列表
  this.getCardList = function (params, noLoadFlag, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Card/QueryOption', params, { headers: { noLoading: noLoadFlag }, cancelToken: cancelToken }).then((res) => {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
  // 查询user
  this.getUserList = function (searchParams, loadFlag, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('User/Paging', searchParams, { headers: { noLoading: loadFlag }, codes: ['M_User'], cancelToken: cancelToken }).then(function (res) {
      if (res.data.success) {
        let userInfo = res.data.data;
        userInfo.items.forEach(item => {
          item.identifyCardResults.sort((a, b) => {
            return (b.canIdentify - a.canIdentify);
          });
        });
        deferred.resolve(userInfo);
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  },
  // 查询user
  this.getUserOptions = function (searchParams, loadFlag, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('User/PagingSimpleUser', searchParams, { headers: { noLoading: loadFlag }, cancelToken: cancelToken}).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
  // 查询Schedule
  this.getScheduleList = function (searchParams, loadFlag, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Schedule/Paging', searchParams, { headers: { noLoading: loadFlag }, cancelToken: cancelToken }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data.items, res.data.data)
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
  this.getScheduleOptions = function (searchParams, loadFlag, cancelToken) {  
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Schedule/PagingOption', searchParams, { headers: { noLoading: loadFlag }, cancelToken: cancelToken }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data.items, res.data.data)
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }

  // schedule坐标转化为时间显示
  this.transformTime = function (timeList, unit) {
    let array = [];
    timeList.forEach((day, index) => {
      let result = [];
      let i = 0;
      day.sort((a, b) => a - b);
      day.forEach((time, timeIndex) => {
        if (timeIndex === 0) {
          result[0] = [time];
        }
        else if (time - day[timeIndex - 1] === 1) {
          result[i].push(time);
        } else {
          result[++i] = [time];
        }
      });
      array[index] = result;
    });

    let showTimeArray = [];
    array.forEach((day, index) => {
      day.forEach((timeSlot, slotIndex) => {
        if (timeSlot.length > 1) {
          // 第一个目录显示周几
          showTimeArray[index] = (slotIndex === 0 ? window.eventBus.common.weekDays[index] + ': ' : showTimeArray[index] + ',') + getTimeCode(timeSlot[0], 0, unit) + ' - ' + getTimeCode(timeSlot[timeSlot.length - 1], 1, unit);
        } else if ((timeSlot.length === 1)) {
          showTimeArray[index] = (slotIndex === 0 ? window.eventBus.common.weekDays[index] + ': ' : showTimeArray[index] + ',') + getTimeCode(timeSlot[0], 0, unit) + ' - ' + getTimeCode(timeSlot[0], 1, unit);
        }
      })
    });

    // type -- 0为开始时间,1为结束时间
    function getTimeCode(moment, type, unit) {
      let time = (type === 0) ? toFix(parseInt((moment * unit * 60) / 3600)) + ':' + toFix(Math.abs((((moment * unit * 60) % 3600 - unit * 60)))) : toFix(parseInt((moment * unit * 60) / 3600)) + ':' + toFix((moment * unit * 60) % 3600);
      let count = moment * unit * 60;
      if (type === 0) {
        if (count % 3600 === 0) {// 如果能够整除，则需要考虑是否为该小时内最后一个单位长度，如单位为5min,值为12时可能为 00:55 - 1:00
          time = toFix(parseInt(count / 3600 - 1)) + ':' + toFix(Math.abs(((count % 3600 - (60 - unit)))));
        } else {
          time = toFix(parseInt(count / 3600)) + ':' + toFix(Math.abs(((count % 3600 - unit * 60) / 60)));
        }
      } else {
        time = toFix(parseInt(count / 3600)) + ':' + toFix(count % 3600 / 60);
      }
      return time;
    }
    // 不足两位前面补充0
    function toFix(num) {
      return ('' + num).length < 2 ? ((new Array(2 + 1)).join('0') + num).slice(-2) : '' + num;
    }
    return showTimeArray;
  }

  //schedules详情数据转化
  this.makeScheduleDetail = function (data) {
    let showTimeArray = [];
    data.forEach(item => {
      item.times.sort((a, b) => {
        return a.startTime - b.startTime;
      });
      showTimeArray.push(window.eventBus.common.weekDays[item.week] + ' : ' + item.times.map(time => this.dayToTime(time.startTime) + ' - ' + this.dayToTime(time.endTime)).toString());
    });
    return showTimeArray;
  }
  /*转换时间格式*/
  this.dayToTime = function (time) {
    time = (time === 86399) ? 86400 : time
    let hour = Math.floor(time / 3600),
      min = (time % 3600) / 60;
    let hourString = hour.toString(),
      minString = min.toString();
    if (hourString.length === 1) {
      hour = '0' + hour
    }
    if (minString.length === 1) {
      min = '0' + min
    }
    return hour + ' : ' + min
  }
  // 时间组合
  this.makeUpTime = function (timeList, unit) {
    if (unit <= 30) {
      return this.transformTime(timeList, unit);
    }
    // 1day
    else {
      let showTimeArray = [];
      timeList.forEach((data, index) => {
        if (data.length > 0) {
          showTimeArray[index] = window.eventBus.common.weekDays[index] + ':' + '00:00 - 24:00'
        }
      });
      return showTimeArray;
    }
  }

    // 图片路径获取
    this.getImgUrl = function (id) {
      let deferred = $.Deferred();
      if (id) {
        window.eventBus.$ajax.get('Files/GetBase64/' + id, { baseURL: window.g.FILE_ROOT, headers: { noLoading: true } }).then((res) => {
          if (res.data.data) {
            deferred.resolve(res.data.data.fileData);
          } else {
            deferred.reject('Get Picture Exception');
          }
        }).catch(() => {
          deferred.reject('Get Picture Exception');
        });
      } else {
        deferred.reject('Get Picture Exception');
      }
      return deferred;
    }

  // 获取包含图片的列表
  this.getListWithImgUrls = function (tableData, inputKey, outputKey, needLoading) {
    let deferred = $.Deferred();
    let arr = JSON.parse(JSON.stringify(tableData));
    let count = 0;
    if (arr.length === 0) {
      deferred.resolve(arr);
    }
    let imgsObj = {};
    for (let index in arr) {
      let fieldId = arr[index][inputKey];
      if (fieldId) {
        if (imgsObj[fieldId]) {
          imgsObj[fieldId].arr.push(index);
          this.imgTableDataBack(++count, arr, index, outputKey, "", deferred, imgsObj);
        } else {
          imgsObj[fieldId] = {
            index: index,
            arr: []
          };
          this.getImgUrl(fieldId, needLoading).done(result => {
            this.imgTableDataBack(++count, arr, index, outputKey, result, deferred, imgsObj);
          }).fail(() => {
            this.imgTableDataBack(++count, arr, index, outputKey, "", deferred, imgsObj);
          });
        }
      } else {
        this.imgTableDataBack(++count, arr, index, outputKey, "", deferred, imgsObj);
      }
    }
    return deferred;
  }

  // 获取包含图片的列表回调
  this.imgTableDataBack = function (count, arr, index, outputKey, result, deferred, imgsObj) {
    arr[index][outputKey] = result;
    if (count === arr.length) {
      for (let key in imgsObj) {
        let k = imgsObj[key].index;
        let indexArr = imgsObj[key].arr;
        indexArr.forEach((item) => {
          arr[item][outputKey] = arr[k][outputKey];
        })
      }
      deferred.resolve(arr);
    }
  }

  /**
   * 页面表格排序
   * vm:组件实例的this;
   * data:iView Table组件on-sort-change事件回调参数;
   * updateFn:更新table数据的方法;
   * tableRef: Table组件的引用，默认'utmTable';
   * */
  this.sortTable = function (vm, data, updateFn, tableRef) {
    let tableOrder = 'desc';
    let ref = tableRef || 'utmTable';
    /*列表排序，用于记录上次排序*/
    //如果点击后排序为normal，即无排序，就手动排序为asc
    if (data.order === 'normal') {
      let index = -1;
      //handleSort需要index参数来确定是第几列，使用columns和data.column的key值对比来查询
      vm.$refs[ref].columns.some((item, i) => {
        if (item.title === data.column.title) {
          index = i;
          return true
        }
      });
      //index不为-1，则手动调用handleSort，这里this.$refs[ref]指向表格组件，需要在表格中写ref
      tableOrder = tableOrder === 'asc' ? 'desc' : 'asc';
      index > -1 && vm.$refs[ref].handleSort(index, tableOrder);
    } else {
      tableOrder = data.order;
      vm.searchParams.sortName = data.column.sortKey || data.column.slot || data.column.key;
      vm.searchParams.sortType = tableOrder === 'asc' ? 0 : 1;
      if (updateFn && typeof updateFn === 'function') {
        updateFn();
      }
    }
  }

  // 获取所有地图
  this.getAllMap = function (searchParams, loadFlag) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Map/Paginate', searchParams, { headers: { noLoading: loadFlag }, codes: ['M_Map'] }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      }
    });
    return deferred;
  }
  this.getMapOptions = function (searchParams, loadFlag) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Map/GetOptions', searchParams, { headers: { noLoading: loadFlag }}).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      }
    });
    return deferred;
  }
  //获取所有区域
  this.getAreaOptions = function (searchParams, loadFlag) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Area/GetOptions', searchParams, { headers: { noLoading: loadFlag } }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      }
    });
    return deferred;
  }
  /*分页获取所有区域*/
  this.getAreaList = function (searchParams, loadFlag, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Area/Paginate', searchParams, { headers: { noLoading: loadFlag }, cancelToken: cancelToken }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data.items, res.data.data)
      }
    });
    return deferred;
  }
  //获取所有设备
  this.getAllDevice = function (searchParams, loadFlag) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Device/QueryOptions', searchParams, { headers: { noLoading: loadFlag } }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      }
    });
    return deferred;
  }
  //分页获取所有设备
  this.getDeviceOptions = function (searchParams, loadFlag, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Device/PagingOptions', searchParams, { headers: { noLoading: loadFlag }, cancelToken: cancelToken }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      }
    });
    return deferred;
  }
  //获取下拉选项的 Access Zone
  this.getAccessZoneOptions = function (searchParams, loadFlag, cancelToken) {
    let deferred = $.Deferred();
    searchParams = searchParams || { keyword: '' };
    window.eventBus.$ajax.post('AccessZone/GetOptions', searchParams, { headers: { noLoading: loadFlag }, cancelToken: cancelToken }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data.items, res.data.data)
      }
    });
    return deferred;
  }

  // 根据id获取事件消息详情
  this.getMsgDetailById = function (eventId) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.get('IncidentRecord/GetDetail?id=' + eventId).then(function (res) {
      if (res.data.success && res.data.data) {
        // 处理节点显示信息
        if (res.data.data.targetNodes) {
          res.data.data.targetNodeName = '-';
          for (let nodeId in res.data.data.targetNodes) {
            res.data.data.targetNodeName = res.data.data.targetNodes[nodeId];
          }
        }
        deferred.resolve(res.data.data)
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
  // 查询自定义字段
  this.getCustomFields = function (params) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Customize/Query', params).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      } else {
        deferred.reject(res.data.message);
      }
    });
    return deferred;
  }
  // 获取卡类型
  this.getCardTypes = function () {
    let deferred = $.Deferred();
    window.eventBus.$ajax.get('Card/QueryCardType', { codes: ['M_CardManagement'], headers: { noLoading: true } }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      }
    });
    return deferred;
  }
  // 获取user默认AC
  this.getDefaultAC = function (params) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Tag/QuerySystemTag', params).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      }
    });
    return deferred;
  }
  // 模板下载
  this.downloadTemplate = function (url, fileName, isLicense) {
    /*url: 下载的API  fileName:模板名称(包含文件类型，如.xlsx)*/
    let header = { responseType: 'blob' };
    if (isLicense) {
      header = { responseType: 'blob', baseURL: window.g.LICENSE_ROOT }
    }
    window.eventBus.$ajax.get(url, header).then((res) => {
      const blob = res.data;
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = (e) => {
        const a = document.createElement('a');
        a.download = fileName;
        a.href = e.target.result;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
    })
  }
  // post方式下載模板
  this.pDownloadTemp = function (url, fileName) {
    window.eventBus.$ajax.get(url, { responseType: 'blob' }).then((res) => {
      const blob = res.data;
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = (e) => {
        const a = document.createElement('a');
        a.download = fileName;
        a.href = e.target.result;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
    })
  }
  // 获取实时视频地址
  this.getRealVideoUrl = function (id) {
    let deferred = $.Deferred();
    let url = window.g.AVIGILON_ROOT + '/Camera/RealTimePlaying?cameraId=' + id;
    deferred.resolve(url);
    return deferred;
  }
  // 获取回放视频地址
  this.getBackVideoUrl = function (id, time) {
    let deferred = $.Deferred();
    let startTime = window.eventBus.moment(time).subtract(30, 'seconds').valueOf();
    let endTime = window.eventBus.moment(time).add(30, 'seconds').valueOf();
    let url = window.g.AVIGILON_ROOT + 'Camera/Playback?cameraId=' + id + '&startTime=' + startTime + '&endTime=' + endTime;
    deferred.resolve(url);
    return deferred;
  }
  // USER AC状态判断 
  this.getUserACStatus = function (period, enableState, vm) {
    // 0:Enable 1:Disable 2:Expired
    if (typeof enableState === 'undefined' && typeof period.enableState === 'number') {
      enableState = period.enableState;
    }
    let curTime = vm.momentTimezone().tz(vm.timeZoneId  || 'Etc/UTC').format('YYYY-MM-DD HH:mm');
    let startTime = vm.common.formatDate(period.validityStartTime, vm.$root.Time[vm.$root.Time.type].typeDateHM,true);
    let endTime = period.validityEndTime ? vm.common.formatDate(period.validityEndTime, vm.$root.Time[vm.$root.Time.type].typeDateHM,true) : null;
    let status = (enableState === 1) ? 1 : 0;
    //Expired
    if (endTime && vm.moment(endTime).isSameOrBefore(curTime)) {
      status = 2;
    }
    // Inactive
    else if (startTime && vm.moment(startTime).isAfter(curTime)) {
      status = 3;
    }
    return status;
  }
  // user/Vehicle 状态切换（Expired和Inactive 不可操作）
  this.getOperateStatus = function (vm, obj) {
    vm['disableFlag'] = false;
    let startTime = vm.common.formatDate(vm[obj].validityStartTime, vm.$root.Time[vm.$root.Time.type].typeDateHM,true);
    let endTime = vm[obj].validityType === 0 ? null : vm.common.formatDate(vm[obj].validityEndTime, vm.$root.Time[vm.$root.Time.type].typeDateHM,true);
    let curTime = vm.momentTimezone().tz(vm.timeZoneId || 'Etc/UTC').format('YYYY-MM-DD HH:mm');
    vm[obj]['status'] = vm[obj]['enableState'] ? 0 : 1;
    // Inactive
    if((vm[obj].validityType === 0 && startTime && vm.moment(startTime).isAfter(curTime)) || (vm[obj].validityType === 1 && startTime &&  vm.moment(startTime).isAfter(curTime))){
      vm['disableFlag'] = true;
      vm[obj]['status'] = 3;
    }
    // Expired
    else if(vm[obj].validityType === 1 && endTime && vm.moment(endTime).isSameOrBefore(curTime)){
      vm['disableFlag'] = true;
      vm[obj]['status'] = 2;
    }
  }
  // 根据文件id获取文件内容
  this.getFileContent = function (file) {
    window.eventBus.$ajax.get('Files/Get/' + file.fileId, { responseType: 'blob', baseURL: window.g.FILE_ROOT, headers: { noLoading: true } }).then((res) => {
      const blob = res.data;
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = (e) => {
        const a = document.createElement('a');
        a.download = file.fileName;
        a.href = e.target.result;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
    })
  }
  // 打开tab列表隐藏选项
  this.openMoreTabs = function (e) {
    if (e.target.className.indexOf('more-tab-item') > -1) {
      $(e.target).find('.other-tab-box').slideDown(300);
      $(e.target).find('.more-tab-arrow').css({ transform: 'rotate(180deg)' });
    } else {
      $(e.target).parents('.more-tab-item').find('.other-tab-box').slideDown(300);
      $(e.target).parents('.more-tab-item').find('.more-tab-arrow').css({ transform: 'rotate(180deg)' });
    }
  }
  // 获取配置的的ID数量
  this.getUserIDCount = function (type) {
    let addIdentityCards = [{ type: 1, no: "", canIdentify: true }];
    let viewInfo = window.eventBus.ApiService.identityInfo.displayNumber;
    let userType = '';
    if (type === 0) {
      userType = 'Staff';
    }
    else if (type === 1) {
      userType = 'Visitor';
    }
    else if (type === 2) {
      userType = 'Vendor';
    }
    else if (type === 3) {
      userType = 'Tenant';
    }
    if (viewInfo) {
      for (let i = 1; i < viewInfo[userType]; i++) {
        addIdentityCards.push({ type: 1, no: "" });
      }
    }
    return addIdentityCards;
  }
  // user数据整合更新
  this.userInfoIntegrate = function (oldInfo, newInfo) {
    let data = {
      basicInfo: {},
      customFields: [],
      userACData: [],
      tempAccessData: []
    };
    // 新的人如果上传了人脸，需将旧的faceFileId置空
    if (newInfo['faceFileBase64']) {
      oldInfo['faceFileId'] = null;
    }
    // 基本信息
    for (let key in oldInfo) {
      if (Array.isArray(newInfo[key]) && key !== 'tagIds') {//tag数据用新数据
        let set1 = new Set(newInfo[key]);
        let set2 = new Set(oldInfo[key]);
        data.basicInfo[key] = Array.from(new Set([...set1, ...set2]));
        // IC去重
        if (key === 'addIdentityCards') {
          data.basicInfo[key] = this.dataDeduplication(data.basicInfo[key], 'type');
        }
      }
      else if(key === 'cardId' && oldInfo.cardId){//如果原来数据有卡号则不更新卡号
        data.basicInfo[key] = oldInfo[key];
      }else{
        data.basicInfo[key] = newInfo[key];
      }
      // else if (key === 'cardId' && oldInfo.cardId) {//如果原来数据有卡号则不更新卡号
      //   data.basicInfo[key] = oldInfo[key];
      // } else if (newInfo[key] || newInfo[key] === 0 || newInfo[key] === false) {
      //   data.basicInfo[key] = newInfo[key];
      // } else {
      //   data.basicInfo[key] = oldInfo[key];
      // }
    }
    // 自定义字段 
    if (newInfo.customFields) {
      newInfo.customFields.forEach(item => {
        if (item.content) {
          data.customFields.push(item);
        } else {
          let index = oldInfo.customFields.findIndex(field => field.id === item.id);
          if (index > -1) {
            data.customFields.push(oldInfo.customFields[index]);
          }
        }
      });
    }
    // AC 当新的信息有AC和合并旧的和新的AC,如果新的没有AC则保留旧的AC PS：如果是覆盖过来的AC需要将原有的uuid删除，会导致保存不成功
    if (newInfo.userACData && newInfo.userACData.length > 0) {
      let newAC = newInfo.userACData.map(ac => {
        delete ac.id;
        return ac;
      });
      data.userACData = newAC.concat(oldInfo.userACData);
    } else {
      data.userACData = oldInfo.userACData;
    }
    // Temp AC
    if (newInfo.tempAccessData && newInfo.tempAccessData.length > 0) {
      data.tempAccessData = newInfo.tempAccessData;
    } else {
      data.tempAccessData = oldInfo.tempAccessData;
    }
    data.basicInfo.replacementId = newInfo.id || undefined;
    return data;
  }
  // 获取AC列表
  this.getACList = function (params, noLoading, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('AccessCode/QueryOption', params, {
      headers: {
        noLoading: noLoading
      }, cancelToken: cancelToken
    }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      } else {
        deferred.reject(res.data.message);
      }
    }).catch((err) => {
      deferred.reject(err);
    });
    return deferred;
  }
  // 获取缓存搜索条件
  this.getCacheSearchInfo = function (thisArg, fuc, key, searchParams, viewParams,searchParamsStr,pageInfo) {
    /*thisArg--this指向
    fuc--查询方法
    searchParams--绑定的搜索参数名称默认为'searchData'
    viewParams--绑定的搜索参数名称默认为'paramsData'*/
    let _this = this;
    let searObj = searchParams || 'searchData';
    let viewObj = viewParams || 'paramsData';
    let pageInfoObj = pageInfo || 'pageInfo'
    let searchParamsObj = searchParamsStr || 'searchParams'
    let searchInfo = window.eventBus.ApiService.cacheSearchInfo;
    this.getPerPage(key, thisArg, callBack,searchParamsObj,pageInfoObj);
    function callBack() {
      // 判断是否存在缓存条件
      if (JSON.stringify(searchInfo) !== '{}') {
        thisArg[searObj] = _this.deepCopy(searchInfo);
        thisArg[viewObj] = _this.deepCopy(searchInfo);
        thisArg['$refs'].searchBar.refactoringData(searchInfo);
      } else {
        // 判断是否需要默认传office的查询条件(当右上角选择了具体的Office则需要默认传参)
        if(thisArg[searObj].isNeedOffice && thisArg.$root.curOfficeInfo.id){
          thisArg[searchParamsObj].officeIds = [thisArg.$root.curOfficeInfo.id];
        }
        fuc();
      }
    }
  }
  this.deepCopy = function (data, hash = new WeakMap()) {
    if (typeof data !== 'object' || data === null) {
      throw new TypeError('传入参数不是对象')
    }
    // 判断传入的待拷贝对象的引用是否存在于hash中
    if (hash.has(data)) {
      return hash.get(data)
    }
    let newData = {};
    const dataKeys = Object.keys(data);
    dataKeys.forEach(value => {
      if (value === 'query') {
        data[value] = '';
      }
      const currentDataValue = data[value];
      // 基本数据类型的值和函数直接赋值拷贝
      if (typeof currentDataValue !== "object" || currentDataValue === null) {
        newData[value] = currentDataValue;
      } else if (Array.isArray(currentDataValue)) {
        // 实现数组的深拷贝
        newData[value] = [...currentDataValue];
      } else if (currentDataValue instanceof Set) {
        // 实现set数据的深拷贝
        newData[value] = new Set([...currentDataValue]);
      } else if (currentDataValue instanceof Map) {
        // 实现map数据的深拷贝
        newData[value] = new Map([...currentDataValue]);
      } else {
        // 将这个待拷贝对象的引用存于hash中
        hash.set(data, data)
        // 普通对象则递归赋值
        newData[value] = deepCopy(currentDataValue, hash);
      }
    });
    return newData;
  }
  /*获取车辆*/
  this.getVehicleList = function (searchParams, loadFlag) {
    let deferred = $.Deferred();
    searchParams = searchParams || {};
    window.eventBus.$ajax.post('Vehicle/QueryOptions', searchParams, { headers: { noLoading: loadFlag } }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      }
    });
    return deferred;
  }
  // 获取user自动分配卡号
  this.getDefaultCard = function (type, nodeId, vm) {
    let deferred = $.Deferred();
    let pagram = {
      userType: type,
      syncNodeIds: vm.$root.nodes.filter(it => { return it.id === nodeId }).length ? [vm.$root.nodes.filter(it => { return it.id === nodeId })[0].syncNodeId] : [],
    };
    window.eventBus.$ajax.post('Card/GetUnUsedCard', pagram).then(function (res) {
      if (res.data.success) {
        let cardInfo = res.data.data;
        let nainType = window.eventBus.ApiService.cardSettingInfo.mainType;
        if (cardInfo) {
          for (let obj of cardInfo.cardExtensionBaseDtos) {
            if (obj.type === nainType) {
              cardInfo.cardText = obj.no;
              break;
            }
          }
        } else {
          res.data.data = { id: '', cardText: '' };
        }
        deferred.resolve(res.data.data); 
      }
    });
    return deferred;
  }
  this.checkIsAllLocation = function (isGroup, titleData, str, option) {
    let string = str || 'buildingName';
    let locationIndex = option && option.locationIndex ? option.locationIndex : 2;
    let isAll = true, array = titleData;
    if (isAll && !isGroup) {
      let obj = {
        title: 'Location', key: string, minWidth: 140
      };
      //判断是否为自定义列表字段
      if(Array.isArray(array)){
        array.splice(locationIndex, 0, obj);
      }else if(typeof array === 'object'){
        array['Location'] = obj;
      }
    } else if (isAll && isGroup) {
      if ( array.user) {
        array.user['Location'] = { title: 'Location', key: string, minWidth: 140 }
      } else if (array.vehicle) {
        array.vehicle['Location'] = { title: 'Location', key: string, minWidth: 140 }
      }else if (array.device) {
        array.device['Location'] = { title: 'Location', key: string, minWidth: 140 }
      }else {
        array.basic['Location'] = { title: 'Location', key: string, minWidth: 140 }
      }
    }

    //判断是否需要添加Office
    let officeStr = option && option.officeField ? option.officeField : 'officeName';
    if (isAll && !isGroup) {
      
      //判断是否为自定义列表字段
      if(Array.isArray(array)){
        let obj = {
          title: 'Office', key: officeStr, minWidth: 170,render: (h, params) => {
            return h('span', {}, [
              h('utm-ellipsis', {
                props: {
                  content: params.row[officeStr],
                  transfer:true
                }
              }),
              params.row[officeStr] && params.row['timeZoneName'] ? h('span', {
                class:'desc-span',
              }, '(' + params.row['timeZoneName'] + ')') : ''
            ])
          }
        }; 
        array.splice(locationIndex + 1, 0, obj);
      }else if(typeof array === 'object'){
        let obj = {
          title: 'Office', key: officeStr, minWidth: 170, showOffice:true, officeStr:officeStr
        }; 
        array['Office'] = obj;
      }
    } else if (isAll && isGroup) {
      if (array.user) {
        array.user['Office'] = { title: 'Office', key: '', minWidth: 170, showOffice:true, officeStr:officeStr}
      } else if (array.vehicle) {
        array.vehicle['Office'] = { title: 'Office', key: officeStr, minWidth: 170, showOffice:true, officeStr:officeStr}
      }  else if (array.device) {
        array.device['Office'] = { title: 'Office', key: officeStr, minWidth: 170, showOffice:true, officeStr:officeStr}
      }else {
        array.basic['Office'] = { title: 'Office', key: officeStr, minWidth: 170, showOffice:true, officeStr:officeStr}
      }
    }
    console.log(array);
    return array
  }

  // DCS Profile
  this.getDCSProfileList = function (ref, params, obj) {
    // ref -- this  obj -- 子组件定义对象
    if (window.eventBus.ApiService.isOpenDCS) {
      let target = obj || 'profileList';
      params = params || { enabledPaging: false, sortName: "name", sortType: 0 };
      window.eventBus.$ajax.post('DCSProfile/Paging', params).then(function (res) {
        if (res.data.success) {
          ref[target] = res.data.data.items;
        }
      });
    }
  }
  // DCS Zone
  this.getDCSZoneList = function (searchParams, noLoading, cancelToken) {
    let deferred = $.Deferred();
    searchParams = searchParams || {};
    window.eventBus.$ajax.post('DCSZone/Paging', searchParams, { headers: { noLoading: noLoading }, cancelToken: cancelToken }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      }
    });
    return deferred;
  }
  // AC选择项
  this.getACOptions = function (params, noLoading, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('AccessCode/QueryOption', params, { headers: { noLoading: noLoading }, cancelToken:cancelToken}).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data.items)
      }
    });
    return deferred;
  }
  // 获取节点信息
  this.getNodeInfo = function (obj) {
    let target = obj.targetNodes;
    if (!$.isEmptyObject(target)) {
      return { id: Object.keys(target)[0], name: target[Object.keys(target)[0]] }
    } else {
      return { id: null, name: null };
    }
  }
  // 相同ID类型验证
  this.idTypeVerify = function (flag, userInfo, index) {
    if (!flag) {
      let arr = userInfo.addIdentityCards;
      arr.forEach((item, curIndex) => {
        if (index !== curIndex && item.type === arr[index].type) {
          // 主卡类型与其他类型重叠时，将次卡号类型置空
          if (index === 0) {
            userInfo.addIdentityCards[curIndex].type = '';
          } else {
            userInfo.addIdentityCards[index].type = '';
          }
        }
      });
    }
  }
  // 数据去重
  this.dataDeduplication = function (data, field) {
    // 默认以id去重
    let obj = field || 'id';
    const map = new Map();
    for (const item of data) {
      if (!map.has(item[obj])) {
        map.set(item[obj], item);
      }
    }
    return [...map.values()];
  }
  // 获取当前时间前dayNum天的时间戳
  this.getDateTime = function (dayNum) {
    let it = new Date().toString().split(" ")
    let dateDay1 = it[0] + ' ' + it[1] + ' ' + it[2] + ' ' + it[3] + ' 00:00:00 ' + it[5] + ' ' + it[6];
    let dateDay = new Date(dateDay1);
    let timeSpan = new Date(dateDay.setDate(dateDay.getDate() - (dayNum - 1))).getTime() //获取dayNum天前的日期；
    return timeSpan

  }
  // 切换节点
  this.changeNode = function (data, obj) {
    if (data) {
      obj.targetNodeName = data.label;
    }
  }
  // 下载
  this.downloadRecord = function (searchParams) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('GenerateReport/Create', searchParams).then(function (res) {
      if (res.data.success) {
        deferred.resolve();
        window.eventBus.messageNotice('info', 'Report is being generated,please go to "Download Center" to download', 'Download Prompt', 5);
      }
    });
    return deferred;
  }
  // 自定义排序
  this.customSort = function (vm, data, targetArr, tableRef) {
    // data:列数据 targetArr：列表数据
    let tableOrder = 'desc';
    let ref = tableRef || 'cusTable';
    /*列表排序，用于记录上次排序*/
    //如果点击后排序为normal，即无排序，就手动排序为asc
    if (data.order === 'normal') {
      let index = -1;
      //handleSort需要index参数来确定是第几列，使用columns和data.column的key值对比来查询
      vm.$refs[ref].columns.some((item, i) => {
        if (item.title === data.column.title) {
          index = i;
          return true
        }
      });
      //index不为-1，则手动调用handleSort，这里this.$refs[ref]指向表格组件，需要在表格中写ref
      tableOrder = tableOrder === 'asc' ? 'desc' : 'asc';
      index && vm.$refs[ref].handleSort(index, tableOrder);
    } else {
      tableOrder = data.order;
      let attr = data.column.sortKey || data.column.slot || data.column.key;
      if (attr === 'accessCodeName' || attr === 'hostUserName' || attr === 'source') {
        targetArr.sort(sortByText);
      } else {
        targetArr.sort(sortByNum);
      }

      // 文本排序
      function sortByText(a, b) {
        return (tableOrder === 'asc' ? b[attr].localeCompare(a[attr]) : a[attr].localeCompare(b[attr]));
      }
      // 时间或数字排序
      function sortByNum(a, b) {
        // 部门AC > 状态 > 时间 > 名称
        if (attr === 'userAccessCodeSource' && a[attr] !== b[attr]) {
          a[attr] = (a[attr] ? a[attr] : 0);
          b[attr] = (b[attr] ? b[attr] : 0);
          return (tableOrder === 'desc' ? b[attr] - a[attr] : a[attr] - b[attr]);
        }
        else if (a['viewStatus'] !== b['viewStatus']) {
          return (tableOrder === 'asc' ? b['viewStatus'] - a['viewStatus'] : a['viewStatus'] - b['viewStatus']);
        }
        else if (a['lastUpdateTime'] !== b['lastUpdateTime']) {
          return (tableOrder === 'asc' ? a['lastUpdateTime'] - b['lastUpdateTime'] : b['lastUpdateTime'] - a['lastUpdateTime']);
        }
        else return (tableOrder === 'asc' ? b.accessCodeName.localeCompare(a.accessCodeName) : a.accessCodeName.localeCompare(b.accessCodeName));
      }
    }
  }
  this.initDcsInfo = function (data) {
    let dCSZoneRelations = [];
    data.forEach((item) => {
      let startDCSAutoZoneId = null;
      if (item.startDCSAutoZone) {
        startDCSAutoZoneId = item.startDCSAutoZone.id;
      }
      let endDCSAutoZoneId = null;
      if (item.endDCSAutoZone) {
        endDCSAutoZoneId = item.endDCSAutoZone.id;
      }
      let dcsAccessZoneIds = item.dcsAccessZones.map((child) => {
        return child.id;
      });;
      
      let dcsProfileId = null;
      if (item.dcsProfile) {
        dcsProfileId = item.dcsProfile.id;
      }
      dCSZoneRelations.push({
        value: {
          targetNodeId: item.buildingId,
          dcsAccessZoneIds: dcsAccessZoneIds,
          startDCSAutoZoneId: startDCSAutoZoneId,
          endDCSAutoZoneId: endDCSAutoZoneId,
          dcsProfileId: dcsProfileId,
          disNodeIds: []
        }
      });
    });
    return dCSZoneRelations;
  }
  // 获取节点User配置
  this.getNodeUserConfig = function (targetNodeId, callback) {
    let params = {
      queryNodeId: targetNodeId,
      // keys:[]
    };
    window.eventBus.$ajax.get('SystemSetting/GetNodeSettings', {
      params: params, paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      }
    }).then(function (res) {
      let _this = window.eventBus;
      if (res.data.success) {
        let result = res.data.data;
        
        const { Staff, Visitor, Vendor, Tenant } = result['system.setting.node.palm.print.configuration.enabled']
        _this.ApiService.palmTypes = [Staff && 0, Visitor && 1, Vendor && 2, Tenant && 3].filter(item => item !== false)

        //用户默认的电话号码区域
        _this.ApiService.defaultAreaCode = result['system.setting.node.user.default.area.code'];
        //用户类型可使用的卡标签
        let userTypeCardTags = result['system.setting.node.user.type.use.tags'];
        if (JSON.stringify(userTypeCardTags) !== '{}') {
          _this.ApiService.userCardTags = userTypeCardTags;
        }
        //给Visitor添加AC时，默认选中的有效期
        _this.ApiService.visitorACTime = result['system.setting.node.user.accesscode.validity'];
        _this.ApiService.getUserShowFields(result['system.setting.node.user.show.fields']);
        _this.ApiService.reserveAutoAC = {
          departmentAC: result['system.setting.node.department.update.user.accesscode.retain'],
          tenantCompanyAC: result['system.setting.node.tenantcompany.update.user.accesscode.retain']
        };
        _this.ApiService.vendorValidityOption = result['system.setting.node.user.vendor.enabled.validity'];
        _this.ApiService.userFaceRequired = result['system.setting.node.user.face.required'];
        // Visitor/Vendor Company
        _this.ApiService.visitorCompanySet = result['system.setting.node.user.visitor.company.setting'];
        _this.ApiService.vendorCompanySet = result['system.setting.node.user.vendor.company.setting'];
        //自动分配卡的用户类型
        _this.ApiService.cardSettingInfo.autoAssignUserTypes = result['system.setting.node.card.auto.assign.user.types'];
        //主卡号类型
        _this.ApiService.cardSettingInfo.mainType = result['system.setting.node.card.main.type'];
        //卡号必填的用户类型
        _this.ApiService.cardSettingInfo.requiredUserTypes = result['system.setting.node.card.required.user.types'];
        //用户附件的配置
        //是否启用附件功能
        _this.ApiService.attachmentInfo.isEnable = result['system.setting.node.user.attachment.enabled'];
        //开启附件的用户类型
        _this.ApiService.attachmentInfo.userTypes = result['system.setting.node.user.attachment.usertypes'];
        _this.ApiService.mustWrite = result['system.setting.node.user.face.profilephoto.required'];
        let isMasterNode = false;
        if (window.eventBus._vmObject.curNodeInfo && window.eventBus._vmObject.curNodeInfo.isMaster) {
          isMasterNode = true;
        }
        _this.ApiService.getDCSSetting(result, isMasterNode);
        _this.ApiService.getFingerprintSetting(result);
        if (callback) {
          callback();
        }
      }
    });
  }
  // 获取节点配置
  this.getNodeSetting = function (params) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.get('SystemSetting/GetNodeSettings', {
      params: params, paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      }
    }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      }
    });
    return deferred;
  }
  // 单个打印
  this.singleCardPrint = function (user, type,isOpenProfile) {
    user.templateType = type;
    let faceFileId = isOpenProfile ? ( user.profilePhotoFileId || user.faceFileId ) : user.faceFileId;
    if (faceFileId) {
      this.getImgUrl(faceFileId).done(str => {
        user.faceFileBase64 = str;
        eventBus.$emit('userPrint', user);
      }).fail(() => {
        eventBus.$emit('userPrint', user);
      });
    } else {
      eventBus.$emit('userPrint', user);
    }
  }
  // 设置缓存数据
  this.setCacheData = function (params) {
    window.eventBus.$ajax.post('ExclusiveSetting/item', params, { headers: { noLoading: true } })
  }
  // 获取缓存数据
  this.getCacheData = function (key) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.get('ExclusiveSetting/item/' + key, { headers: { noLoading: true } }).then(res => {
      if (res.data.success) {
        deferred.resolve(res.data.data)
      }
    });
    return deferred;
  }
  // 查询页码保留数据
  this.getPerPage = function (key, thisArg, callback, searchParams='searchParams',pageInfo='pageInfo') {
    /*key -- table的每页保留key值 thisArg -- this指向 callback -- 回调*/
    this.getCacheData(key).done(result => {
      if (thisArg[pageInfo]) {
        thisArg[pageInfo].limit = result / 1 || 20;
      }
      if (thisArg[searchParams]) {
        thisArg[searchParams].perPage = result / 1 || 20;
      }
      queryData();
    }).fail(err => {
      queryData();
    });
    function queryData() {
      if (callback) {
        // 判断是否需要默认传office的查询条件(当右上角选择了具体的Office则需要默认传参)
        if(thisArg['searchData'] && thisArg['searchData'].isNeedOffice && thisArg.$root.curOfficeInfo.id){
          thisArg[searchParams].officeIds = [thisArg.$root.curOfficeInfo.id];
        }
        callback();
      }
    }
  }
  /************ESS1.0***************/

  /************PSIM 报表详情***************/
  this.expandInfo = function (e) {
    $('.addition-info').slideToggle(300);
    $(e.target).parents('.addition-info-title').find('.ivu-icon-ios-arrow-down').toggleClass('expand')
  }
  // 获取Asset列表
  this.getAssetList = function (params) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('Device/Paging', params, { urlType: 'ARMS', headers: { noLoading: true } }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      }
    });
    return deferred;
  }
  // 下拉User项（仅有id及name）
  this.queryUseritems = function (params, cancelToken) {
    let deferred = $.Deferred();
    window.eventBus.$ajax.post('User/PagingSimpleUser', params, { headers: { noLoading: true }, cancelToken: cancelToken }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      }
    });
    return deferred;
  }
  // 切换User AC分类
  this.changeACClass = function (vm, type, isClick,fromWhere) {
    vm.classType = type;
    vm.displayACData = vm.userACData.filter(item => {
      //添加不可选中
      if((item.userAccessCodeSource === 1 && fromWhere!='visitor' && fromWhere!='vendor') || (item.userAccessCodeSource === 2 && fromWhere=='tenant')){
        item._disabled = true;
      }else{
        delete item._disabled;
      }
      if (type === 0) {
        return item.viewStatus !== 2;
      } else {
        return item.viewStatus === 2;
      }
    });
    if(isClick){
      if(type==0){
        vm.pageInfoAcExpired = JSON.parse(JSON.stringify(vm.pageInfoAc));
        vm.pageInfoAc = JSON.parse(JSON.stringify(vm.pageInfoAcInUse));
      }else{
        vm.pageInfoAcInUse = JSON.parse(JSON.stringify(vm.pageInfoAc));
        vm.pageInfoAc = JSON.parse(JSON.stringify(vm.pageInfoAcExpired));
      }
    }
    //前端分页
    if(vm.pageInfoAc){
      vm.pageInfoAc.itemCount = vm.displayACData.length || 0;
      vm.pageInfoAc.Total =  Math.ceil(vm.displayACData.length / vm.pageInfoAc.limit) || 1;
      vm.pageInfoAc.currentPage = vm.pageInfoAc.curPage;
      //当删除时到最后一页，则将页数变为总页数
      if (vm.pageInfoAc.Total > 0 && (vm.pageInfoAc.currentPage > vm.pageInfoAc.Total)) { 
        vm.pageInfoAc.currentPage = vm.pageInfoAc.Total;
      }
      vm.pageInfoAc.curPageVal =  vm.pageInfoAc.currentPage;
      vm.displayACData = vm.displayACData.slice((vm.pageInfoAc.curPageVal - 1) * vm.pageInfoAc.limit, Math.min(vm.displayACData.length, vm.pageInfoAc.curPageVal * vm.pageInfoAc.limit)); 
      vm.checkedAcData = [];
    }
  
   
  }
  //添加时切换永久开始时间一直为开始时间，不继承自定义的开始时间，切换自定义清空开始结束时间
  //编辑时原本是自定义时间，切换永久开始时间继承原本的自定义时间的开始时间，切换自定义保留原来的自定义开始结束时间
  this.getValidityStartTime = function (vm, obj, isEdit, original) {
    if (isEdit) {
      if (vm[obj].validityType === 0) {
        vm[obj].validityStartTime = vm[original].startTime;
      } else {
        if (vm[original].startTime && vm[original].endTime) {
          vm[obj].validityStartTime = vm[original].startTime;
          vm[obj].validityEndTime = vm[original].endTime;
        } else {
          vm[obj].validityStartTime = '';
          vm[obj].validityEndTime = '';
        }
      }
    } else {
      if (vm[obj].validityType === 0) {
        vm[obj].validityStartTime = vm.common.formatDate(vm.moment(), vm.$root.Time[vm.$root.Time.type].typeDateHM);
        vm[obj].validityEndTime = '';
        //切换永久清空结束时间
      } else {
        vm[obj].validityStartTime = '';
        vm[obj].validityEndTime = '';
      }
    }
  }
  // user 切换有效期后，AC有效期会跟着变化
  this.updateACValidity = function (vm, obj) {
    for (let i = vm.userACData.length; i--;) {
      vm.userACData[i].viewStatus = this.getUserACStatus(vm.userACData[i],null,vm);
    }
  }
  // user 相关有效期对比
  this.userValidityCompare = function (flag, type, objStr, startAttr, endAttr, vm, userStr) {
    // flag:展开状态 type:开始或结束时间 objStr：有效期对象 startAttr：开始时间 endAttr：结束时间 vm：this指向  userStr：user对象
    if (!flag) {
      let _this = this;
      let startData = vm.common.formatDate(vm[objStr][startAttr], vm.$root.Time[vm.$root.Time.type].typeDateHM, 2);
      let endData = vm.common.formatDate(vm[objStr][endAttr], vm.$root.Time[vm.$root.Time.type].typeDateHM, 2);
      if(startData >= 4070880000000){
        vm[objStr][startAttr] = '';
      }
      if(endData >= 4070880000000){
        vm[objStr][endAttr] = '';
      }
      if ((vm[objStr].validityType === 0 && !startData) || (vm[objStr].validityType === 1 && (!startData || !endData))) {
        return;
      }
      // 大小对比
      if (vm[objStr].validityType === 1) {
        if(startData >= endData){
          if (type === 0) { /*选开始时间*/
            vm[objStr][endAttr] = '';
          } else { /*选结束时间*/
            vm[objStr][startAttr] = '';
          }
        }
        if(startData < 0){
          vm[objStr][startAttr] = '';
        }
        if(endData < 0){
          vm[objStr][endAttr] = '';
        }
      }
      // 获取自动AC
      if (objStr == 'staffInfo' || objStr == 'userInfo' || objStr == 'tenantInfo' || objStr == 'vehicleInfo') {
        if (vm.getAutoACValidity) {
          vm.getAutoACValidity();
        }
        // 改变user有效期，AC有效期会跟随变动
        if ((vm[objStr].validityType === 0 && vm[objStr].validityStartTime) || (vm[objStr].validityStartTime && vm[objStr].validityEndTime)) {
          _this.updateACValidity(vm, objStr);
          _this.getOperateStatus(vm, objStr);
          if (vm.tempAccessData && vm.tempAccessData.length > 0) {
            _this.updateTempACValidity(vm, objStr);
          }
        }
      }
    }
  }
  //更新临时AC的有效期
  this.updateTempACValidity = function (vm, obj) {
    for (let i = vm.tempAccessData.length; i--;) {
      vm.tempAccessData[i].viewStatus = this.getUserACStatus(vm.tempAccessData[i],null,vm);
    }
  }
  // 临时AC与user有效期对比,获取默认有效期
  this.getDeaultTempValidity = function (vm, obj) {
    let startTime = vm.common.formatDate(vm.moment(), vm.$root.Time[vm.$root.Time.type].typeDate) + ' 00:00';
    let endTime = vm.common.formatDate(vm.moment().add(vm.ApiService.tempACSettingInfo.effectiveDays, 'd'), vm.$root.Time[vm.$root.Time.type].typeDate) + ' 00:00';
    return { startTime: startTime, endTime: endTime };
  }
  //判断报表有效期的显示
  this.isPermanent = function (row) {
    if (row.validityStartTime && (row.validityEndTime === null || row.validityEndTime === 253402300799999)) {
      return true;
    } else if (row.validityStartTime && row.validityEndTime && row.validityEndTime !== 253402300799999) {
      return false;
    }
  }
  // 请求接口获取文件流的数据
  this.getFileStream = function (referenceId, offset, sectionSize) {
    let deferred = $.Deferred();
    let sectionSizeNumber = sectionSize || '1024';
    window.eventBus.$ajax.get('Files/getSection/' + referenceId + '/' + offset + '/' + sectionSizeNumber, { baseURL: window.g.FILE_ROOT }).then(function (res) {
      if (res.data.success) {
        deferred.resolve(res.data.data);
      } else {
        window.eventBus.messageNotice('error', res.data.message);
      }
    });
    return deferred;
  }
  this.roleIsProfile = function (type) {
    switch (type) {
      case 0:
        return window.eventBus.ApiService.judgmentSwitch.Staff || false;
      case 1:
        return window.eventBus.ApiService.judgmentSwitch.Visitor || false;
      case 2:
        return window.eventBus.ApiService.judgmentSwitch.Vendor || false;
      case 3:
        return window.eventBus.ApiService.judgmentSwitch.Tenant || false;
      case 99:
        return false;
      default:
        return true
    }
  }
  // 判断是否有权限查看用户详情
  this.canShowUserDetail = function(vm,type){
    let flag = true;
    if(type === 0 && vm.$root.adminInfo.permissionCodes.indexOf('M_ViewStaffList') === -1){
      flag = false;
    }else if(type === 1 && vm.$root.adminInfo.permissionCodes.indexOf('M_ViewVisitorList') === -1){
      flag = false;
    }else if(type === 2 && vm.$root.adminInfo.permissionCodes.indexOf('M_ViewVendorList') === -1){
      flag = false;
    }else if(type === 3 && vm.$root.adminInfo.permissionCodes.indexOf('M_ViewTenantList') === -1){
      flag = false;
    }
    if(!flag){
      vm.messageNotice('error', "You don't have the permissions");
    }
    return flag;
  }
};
const getShareApi = new shareApi();
export default getShareApi;



//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/js/shareAPI.js
// module id = DxNO
// module chunks = 15